window.onload = function () {
    // bc position selectors to check, this will normally be the id of the div
    const bcPositions = ['#bc-home-marketing-1', '#bc-home-marketing-2', '#bc-category-marketing-1'];

    // perform the check for every position
    bcPositions.forEach((selector, index) => {
        checkBcPositions(selector);
    });
};

// check if bc positions are filled and remove d-none class if so
function checkBcPositions(selector) {
    let timer;
    let counter = 0;
    let bcElement = document.querySelector(selector);

    // only continue if the element is on the page
    if (bcElement !== null) {
        // check every 2 seconds if BC has loaded the content, do this a maximum of 3 times
        timer = setInterval(function () {
            counter++;

            // check if the element contains anything, CAREFULL as line breaks count as content too.
            if (bcElement.childNodes.length) {
                // remove the d-none class if content was found
                bcElement.classList.remove("d-none");
                // if content was found stop the interval check
                clearInterval(timer);
            }

            // stop the interval check after 3 tries
            if (counter >= 3) {
                clearInterval(timer);
            }
        }, 2000);
    }
}
